var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWishlistIcon1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1974 2.58002C7.9719 0.354562 4.37152 0.343747 2.15569 2.55959C-0.0601525 4.77542 -0.0493379 8.3758 2.17612 10.6013L10.4142 18.8394C10.7559 19.1811 11.31 19.1811 11.6517 18.8394L19.847 10.6489C22.0577 8.42586 22.0507 4.83557 19.8248 2.60972C17.5954 0.380267 13.9933 0.369451 11.7735 2.58925L10.9908 3.37347L10.1974 2.58002ZM18.6061 9.41492L11.033 16.9832L3.41356 9.36382C1.86986 7.82012 1.86237 5.32777 3.39312 3.79702C4.92387 2.26627 7.41622 2.27376 8.95992 3.81746L10.3763 5.23383C10.7238 5.58138 11.2894 5.57456 11.6285 5.21875L13.011 3.82669C14.5457 2.29197 17.0397 2.29946 18.5874 3.84715C20.1315 5.39124 20.1363 7.87615 18.6061 9.41492Z",
    fill: "#475168"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWishlistIcon1);
export default __webpack_public_path__ + "static/media/wishlist-icon1.5c242649033238aad6755317ea02cb3e.svg";
export { ForwardRef as ReactComponent };